export default __webpack_public_path__ + "static/media/stalker_sports.ee0595db.png";